import { ChevronRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import type { ReactNode } from 'react'

interface Crumb { label: string; to?: string }
interface Props { title: string; subtitle?: string; action?: ReactNode; breadcrumbs?: Crumb[] }

export function PageHeader({ title, subtitle, action, breadcrumbs }: Props) {
  return (
    <div className="mb-6">
      {breadcrumbs && (
        <nav className="flex items-center gap-1 text-xs text-gray-400 mb-2">
          {breadcrumbs.map((c, i) => (
            <span key={i} className="flex items-center gap-1">
              {i > 0 && <ChevronRight size={12}/>}
              {c.to ? <Link to={c.to} className="hover:text-brand-500 transition-colors">{c.label}</Link> : <span className="text-brand-500 font-medium">{c.label}</span>}
            </span>
          ))}
        </nav>
      )}
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div className="min-w-0">
          <h1 className="text-xl font-bold text-gray-900 font-display break-words">{title}</h1>
          {subtitle && <p className="text-sm text-gray-500 mt-0.5">{subtitle}</p>}
        </div>
        {action && <div className="flex-shrink-0 w-full sm:w-auto">{action}</div>}
      </div>
    </div>
  )
}
